module.exports = "/assets/64d1bfddad758c540f2382d7b6ebc385.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VQ.png
// module id = 3054
// module chunks = 0